const FEATURE_USER_PARTICIPATION_TYPE = `
  FEATURE_USER_PARTICIPATION_TYPE {
    feature_user_participation_type {
      id
      name
    }
  }
`;

const featureWorkflowInstance = `
 feature_workflow_instance {
      id
      feature_type_id
      feature_instance_id
      workflow_status
      milestone_state
      effective_float
      current_delay
      pre_WF_start_float
      today_date
      final_deadline_date
      high_risk_threshold
      low_risk_threshold
      risk_level
      risk_assessment
      manual_entry_date
      workflow_template_id
      override_project_threshold
      calculation_details
      wf_override_reason
      lead_time
      are_predecessors_complete
    }
`;
const workflowInstanceMilestones = `
  workflow_instance_milestones {
    id
    sequence_no
    name
    actual_date
    planned_date
    projected_date
    status
    milestone_action
    feature_workflow_instance_offsets_as_src {
      id
      name
      duration
      is_editable
    }
}`;

const FEATURE_INSTANCE_DETAILS_BY_PK = `
 FEATURE_INSTANCE_BY_PK_DETAILS_PACKAGE($featureId: uuid!)  {
  feature_instance_by_pk(id: $featureId) {
    id
    title
    description
    number
    auto_inc_value
    redirect_url
    external_source_id
    deleted_from_source
    created_at
    revision
    created_by_user {
      email
      first_name
      last_name
    }
    feature_type_id
    feature {
      id
      feature
      show_float
    }
    feature_bid_package {
      no_of_bidders
      wave
      awarded_value
      estimated_value
    }
    feature_company_participants {
      vendor_id
      instance_id
      company_participation_type_id
      vendor_unregistered
      vendor {
        name
      }
      vendor_source_info {
        id
        name
        full_source_name
      }
    }
    feature_user_paticipants {
      user_unregistered
      user {
        id
        email
        first_name
        last_name
        status_id
        project_users {
          subscription_vendor {
            name
          }
        }
      }
      user_participation_type_id
      user_participation_type {
        id
        name
      }
      user_unregistered
      user_source_info {
        first_name
        last_name
        vendor_source_info {
          name
        }
      }
    }
    feature_instance_spec_sections {
      bid_scope
      spec_section {
        id
        title
        description
        section_name
        section_number
        specification_id
        file_key
      }
    }
    ${featureWorkflowInstance}
    ${workflowInstanceMilestones}

  successor_material_links: links_as_source(
  where: { target_feature_instance: { deleted: { _eq: false }, implicit: { _eq: false }, feature_type_id: { _eq: 2 }  } }
  order_by: { target_feature_instance: { number: asc, auto_inc_value: asc } }) {
      governing_link
      link_type
      linked_offset_date
      offset_duration
      reverse_dependency
      target_feature_instance {
        id
        implicit
        number
        auto_inc_value
        title
        feature_type_id
        feature {
          show_float
        }
        feature_workflow_instance {
          id
          workflow_status
          risk_level
          milestone_state
        }
        
        feature_instance_spec_sections {
          spec_section {
            section_number
            section_name
            status
            title
          }
        }
      }
    }
  predecessor_material_links: links_as_target (
  where: { source_feature_instance: { deleted: { _eq: false }, implicit: { _eq: false }, feature_type_id: { _eq: 2 } } }
  order_by: { source_feature_instance: { number: asc, auto_inc_value: asc } }) {
      governing_link
      link_type
      linked_offset_date
      offset_duration
      reverse_dependency
      source_feature_instance {
        id
        title
        number
        auto_inc_value
        feature_type_id
        implicit
        deleted_from_source
        revision
        feature {
          show_float
        }
        feature_instance_spec_sections {
          spec_section {
            section_name
            section_number
            title
          }
        }
        
        feature_workflow_instance {
          id
          workflow_status
          milestone_state
          risk_level
        }
      }
    }

    links_as_source {
      governing_link
      link_type
      linked_offset_date
      offset_duration
      reverse_dependency
      target_feature_instance {
        id
        implicit
        number
        auto_inc_value
        title
        feature_type_id
        feature {
          show_float
        }
        ${featureWorkflowInstance}
        ${workflowInstanceMilestones}
        links_as_source {
          governing_link
          link_type
          linked_offset_date
          offset_duration
          reverse_dependency
          target_feature_instance {
            id
            implicit
            number
            title
            auto_inc_value
            feature_type_id
            feature {
              show_float
            }
            ${featureWorkflowInstance}
          }
        }
        feature_workflow_instance {
          risk_level
          milestone_state
        }
        feature_instance_spec_sections {
          spec_section {
            section_number
            section_name
            status
            title
          }
        }
        feature_activities {
          feature_instance_id
          start_date
          end_date
          critical
          total_slack
          actual_start_date
          actual_finish_date
          progress
          total_slack_computed
        }
        deleted_from_source
        feature_submittals{
          workflow_status
        }
      }  
        
      source_feature_instance {
        id
        auto_inc_value
        title
        feature_type_id
        revision
        feature_instance_spec_sections {
          spec_section {
            section_name
            section_number
            title
          }
        }
        workflow_instance_milestones(order_by: {sequence_no: asc_nulls_last}) {
          name
          sequence_no
          actual_date
          projected_date
          planned_date
        }
        feature_submittals {
          workflow_status
          status
          type
          raw_type
        }
        deleted_from_source
      }
    }
    links_as_target {
      governing_link
      link_type
      linked_offset_date
      offset_duration
      reverse_dependency
      source_feature_instance {
        id
        title
        number
        auto_inc_value
        feature_type_id
        implicit
        deleted_from_source
        revision
        feature {
          show_float
        }
        feature_instance_spec_sections {
          spec_section {
            section_name
            section_number
            title
          }
        }
        feature_submittals {
          workflow_status
          status
          type
          raw_type
        }
        ${featureWorkflowInstance}
        ${workflowInstanceMilestones}
        links_as_source {
          link_type
          id
          governing_link
          target_feature_instance {
            title
            feature_type_id
            implicit
            feature_workflow_instance {
              feature_instance_id
            }
          }
        }
        feature_activities {
          feature_instance_id
          start_date
          end_date
          critical
          total_slack
          actual_start_date
          actual_finish_date
          progress
        }
      }
    }
    feature_instance_revisions {
      feature_instance_id
      revision
      data
    }
    feature_submittals {
      priority
      type
      raw_type
      raw_status
      material_tracking
      watchers
      snippet_file_key
      snippet_coordinates
      status
      workflow_status
      submittal_status_history_details(order_by: { created_at: desc }) {
        id
        status
        comment
        action
        on_behalf_of
        on_behalf_of_user {
          id
          last_name
          first_name
          email
          project_users {
            subscription_vendor {
              name
            }
          }
          subscription_users {
            subscription {
              name
            }
          }
        }
        created_at
        created_by
        user {
          first_name
          email
          last_name
          id
          project_users {
            subscription_vendor {
              name
            }
          }
          subscription_users {
            subscription {
              name
            }
          }
        }
        assignee
        assignee_user {
          id
          email
          first_name
          last_name
          subscription_users {
            subscription {
              name
            }
          }
          project_users {
            subscription_vendor {
              name
            }
          }
        }
        submittal_revision
        submittal_response_id
        submittal_response {
          id
          key
          response
        }
        assignee_unregistered
        on_behalf_of_unregistered
      }
    }
    feature_locations {
      location {
        name
        id
        path
      }
    }
    feature_materials {
      warranty
      manufacturer
      part_number
      serial_number
      quantity
      material_size
      tag_name
      material_quantity_unit {
        measurement
        unit
        id
      }
      material_size_unit {
        id
        measurement
        unit
      }
      place_id
      project_location_id
      project_location {
        id
        location_service_id
        location_service {
          label
          municipality
          sub_region
          region
          country
        }
      }
      purchase_order
    }
    feature_instance_histories(order_by: {created_at: desc}) {
      id
      action_description_html
      action_description
      action_type
      created_at
      feature_instance_id
      feature_type_id
      comment
    }
    comments(order_by: {created_at: desc}){
      id
      description
      attachments {
        id
        file_name
        file_type
        file_size
        blob_key
      }
      workflow_step
      workflow_template_id
      created_at
      created_by
      created_by_user {
        email
        first_name
        last_name
        project_users {
          subscription {
            name
          }
        }
      }
    }
  }
}
`;

const FEATURE_ATTACHMENTS = `
  FEATURE_ATTACHMENTS($where: attachments_bool_exp!) {
    attachments(where: $where) {
      submittal_revision
      file_name
      file_size
      submittal_id
      material_id
      id
      comment_id
      blob_key
      version
      uploaded
      created_at
      file_type
      reference_id
      submittal_status_history {
        workflow_status
      }
      created_by_user {
        email
        first_name
        last_name
        project_users {
          subscription {
            name
          }
          subscription_vendor {
            name
          }
        }
      }
      versions {
        id
        comment_id
        blob_key
        version
        uploaded
        file_type
        file_name
        created_at
        submittal_id
        submittal_status_history {
          workflow_status
        }
        created_by_user {
          email
          first_name
          last_name
          project_users {
            subscription {
              name
            }
            subscription_vendor {
              name
            }
          }
        }
      }
      on_behalf_of_user_id
      on_behalf_of
      attachments_user {
        first_name
        id
        last_name
        email
      }
    }
  }
`;

const GET_SCHEDULE_LIST = `
  GET_SCHEDULE_LIST {
    schedule_import_details(
      order_by: { created_at: desc }
      where: { import_log: { import_type: { _eq: SCHEDULE } } }
    ) {
      id
      import_log_id
      is_active
      schedule_name
      schedule_date
      schedule_type
      activated_at
      created_at
      import_log {
        id
        resolved_values_s3_prefix
        source_values_s3_prefix
        created_at
        created_by_user {
          id
          first_name
          last_name
        }
      }
    }
  }
`;

const GET_FEATURE_INSTANCE_PLANNING_DATA = `
  GET_FEATURE_INSTANCE_PLANNING_DATA($featureId: uuid!) {
    feature_instance_by_pk(id: $featureId) {
      id
      title
      feature_type_id
      links_as_source {
        target_feature_instance {
          id
          title
          feature_type_id
          workflow_instance_offsets {
            id
            name
            duration
          }
          workflow_instance_milestones {
            id
            name
            planned_date
            sequence_no
            hidden
          }
          links_as_source {
            id
            target_feature_instance {
              id
              title
              feature_type_id
              workflow_instance_offsets {
                name
                duration
                id
              }
              workflow_instance_milestones {
                id
                name
                planned_date
                sequence_no
                hidden
              }
              links_as_source {
                id
                link_type
                governing_link
                target_activities_instance: target_feature_instance { 
                  id
                  title
                  feature_activities {
                    start_date
                    end_date
                    source_task_id
                    type
                  }
                }
              }
              links_as_source {
                id
                governing_link
                target_feature_instance {
                  id
                  project_id
                  feature_type_id
                  title
                  feature_workflow_instance {
                    id
                    manual_entry_date
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const GET_LINKED_ACTIVITIES = `
  GET_LINKED_ACTIVITIES($featureInstanceId: uuid!) {
  feature_instance(where: {id: {_eq: $featureInstanceId}}) {
    links_as_source {
      id
      link_type
      created_at
      target_activities_instance: target_feature_instance {
        id
        title
        feature_activities {
          start_date
          end_date
          source_task_id
          type
        }
      }
    }
  }
}
`;

const GET_FEATURE_COMMENTS = `
GET_FEATURE_COMMENTS($where: comment_bool_exp) {
  comment(where: $where, order_by: {created_at: desc}) {
    id
    feature_instance_id
    description
    attachments {
      id
      file_name
      file_type
      file_size
      blob_key
    }
    workflow_step
    workflow_step_text
    workflow_template_id
    created_at
    created_by
    created_by_user {
      email
      first_name
      last_name
      project_users {
        subscription {
          name
        }
      }
    }
  }
}
`;

const FEATURE_LIST_BY_FEATURE_TYPE_ID = `
  FEATURE_LIST_BY_FEATURE_TYPE_ID($featureTypeId: Int) {
    feature_instance(where: {feature_type_id: {_eq: $featureTypeId}}) {
    id
    number
    title
    description
  }
}
`;

const GET_CHILD_FEATURE_LINKS = `
  GET_CHILD_FEATURE_LINKS($featureInstanceId: uuid!, $featureTypeId: Int) {
  feature_linking(where: {source_instance_id: {_eq: $featureInstanceId }, target_feature_instance: {feature_type_id: {_eq: $featureTypeId}}}) {
    target_feature_instance {
      id
      created_at
      created_by
      description
      external_source_id
      feature_type_id
      number
      updated_at
      updated_by
      title
    }
    link_type
  }
}
`;

const GET_PARENT_FEATURE_LINKS = `
  GET_PARENT_FEATURE_LINKS($featureInstanceId: uuid!, $featureTypeId: Int) {
  feature_linking(where: {target_instance_id: {_eq: $featureInstanceId }, source_feature_instance: {feature_type_id: {_eq: $featureTypeId}}}) {
    source_feature_instance {
      id
      created_at
      created_by
      description
      external_source_id
      feature_type_id
      number
      updated_at
      updated_by
      title
    }
    link_type
  }
}
`;

const CHECK_FEATURE_FIELD_VALUE_EXISTS = `
  CHECK_FEATURE_FIELD_VALUE_EXISTS($where: feature_instance_bool_exp!) {
  feature_instance(where: $where) {
    id
  }
}
`;

const FEATURE_WORKFLOW_INSTANCE_BY_IDS = `
  FEATURE_WORKFLOW_INSTANCE_FOR_FEATURE_IDS($featureIds: [uuid!]!) {
    feature_workflow_instance(where: {feature_instance_id: {_in: $featureIds}}) {
      feature_instance {
        id
      }
      id
      workflow_instance_milestones {
        id
        sequence_no
        name
        actual_date
        planned_date
        projected_date
        status
        milestone_action
        feature_workflow_instance_offsets_as_src {
          id
          name
          duration
          project_template_offset {
            id
            name
          }
        }
      }
      float
      feature_type_id
      workflow_status
      workflow_template_id
    }
  }
`;

const FEATURE_DISTRIBUTION_GROUP_LIST = `
 FEATURE_DISTRIBUTION_GROUP_LIST($where: feature_distribution_list_bool_exp!) {
  feature_distribution_list(where: $where, distinct_on: user_id) {
    dl_id
    user_id
    distribution_group {
      id
      name
      distribution_group_user {
        user {
          id
          email
          first_name
          last_name
        }
      }
    }
  }
}
`;

const FEATURE_DISTRIBUTION_GROUP_USERS = `
  FEATURE_DISTRIBUTION_GROUP_USERS($where: feature_distribution_list_bool_exp!) {
   feature_distribution_list(where: $where, distinct_on: user_id) {
      user_id
      dl_id
    }
  }
`;

const FEATURE_ACTIVITY_LIST = `
   FEATURE_SCHEDULE_LIST {
    getScheduleDataByProject {
    id
    text
    start_date
    end_date
    duration
    critical
    total_slack_computed
    total_slack
    type
    source_task_id
    import_log_id
    parent
    progress
    actual_finish_date
    actual_start_date
  }
  }
`;

const SUBMITTAL_WORKFLOW_RESPONSES = `
  SUBMITTAL_WORKFLOW_RESPONSES {
    submittal_response {
      key
      response
      id
    }
  }
`;

export {
  FEATURE_USER_PARTICIPATION_TYPE,
  FEATURE_INSTANCE_DETAILS_BY_PK,
  FEATURE_ATTACHMENTS,
  GET_SCHEDULE_LIST,
  GET_FEATURE_INSTANCE_PLANNING_DATA,
  GET_LINKED_ACTIVITIES,
  GET_FEATURE_COMMENTS,
  FEATURE_LIST_BY_FEATURE_TYPE_ID,
  GET_CHILD_FEATURE_LINKS,
  GET_PARENT_FEATURE_LINKS,
  CHECK_FEATURE_FIELD_VALUE_EXISTS,
  FEATURE_WORKFLOW_INSTANCE_BY_IDS,
  FEATURE_DISTRIBUTION_GROUP_LIST,
  FEATURE_DISTRIBUTION_GROUP_USERS,
  FEATURE_ACTIVITY_LIST,
  SUBMITTAL_WORKFLOW_RESPONSES
};
